import {
    hasSocialLinks,
    parseSocialLinksFromQr,
    SOCIAL_ICON_IMG,
} from '@/lib/socialLinks'

function isHttpUrl(value) {
    return typeof value === 'string' && /^https?:\/\//i.test(value.trim())
}

export default function SocialMediaPublicLinks({ qr }) {
    const links = parseSocialLinksFromQr(qr)

    if (!links.length) {
        return null
    }

    return (
        <>
            {links.map(entry => {
                const iconSrc = SOCIAL_ICON_IMG[entry.platform]
                const tooltip =
                    entry.label && !isHttpUrl(entry.label)
                        ? entry.label
                        : entry.platform?.replace(/_/g, ' ') || entry.url

                return (
                    <a
                        key={entry.id}
                        href={entry.url}
                        className="preview-icon-item"
                        target="_blank"
                        rel="noopener noreferrer"
                        title={tooltip}
                        aria-label={tooltip}>
                        {iconSrc ? (
                            <img src={iconSrc} alt="" aria-hidden="true" />
                        ) : (
                            <span className="social-link-fallback">
                                {entry.platform?.replace(/_/g, ' ')}
                            </span>
                        )}
                    </a>
                )
            })}
        </>
    )
}

export { hasSocialLinks }
